<script setup>
// store
const store = useLoginStore()

onMounted(() => {
  if (store.database.selected === null)
    store.database.selected = store.database.list[0]
})
// confirm
const confirm = async () => {
  localStorage.setItem('database', store.database.selected.value)
  if (!await store.loadDomains()) store.showError('Login fehlgeschlagen.')
  store.database.confirmed = true
}
</script>

<template>
  <form @submit.prevent="confirm">
    <div class="row row-cols-1 gy-3 px-3">
      <div class="col">
        <div class="form-group ">
          <Select
            v-model="store.database.selected"
            class=" "
            :pt="
              { root: { class: 'form-select form-control-lg col-12  bg-white' },
                wrapper: { class: 'w-100' },
                label: { class: 'text-secondary ' },
                overlay: { class: '   ' },
                listContainer: { class: 'bg-white mh-100' },
                option: { class: 'text-secondary ' },
              }"
            required
            :options="store.database.list" option-label="name"
          >
            <template #value="slotProps">
              <div class="overflow-hidden text-truncate">
                <i class="fas fa-database me-3 " /> {{ slotProps.value?.name }}
              </div>
            </template>
            <template #option="slotProps">
              <div class="overflow-hidden text-truncate ">
                {{ slotProps.option.name }}
              </div>
            </template>
          </Select>
        </div>
      </div>
      <div class="col">
        <Button
          type="submit"
          class="btn btn-primary btn-block btn-lg w-100"
          label="Confirm"
        />
      </div>
    </div>
  </form>
</template>

<style>
/* :root {
  --p-select-option-focus-background: red !important;
  --p-select-option-focus-color: #495057;
  --p-select-option-selected-background: #e9ecef;
  --p-select-option-selected-color: #495057;
  --p-select-option-selected-focus-background: #e9ecef;
  --p-select-option-selected-focus-color: #495057;
  --p-select-hover-border-color: #8da9c3;
  --p-select-focus-border-color: #8da9c3;
  --p-select-focus-ring-color: rgb(72 106 136 / 25%);
} */
.p-select-option:not(.p-select-option-selected):not(.p-disabled).p-focus {
  background-color: #0d6efd !important;
  color: white !important;

}
.p-select-option.p-select-option-selected {
  background-color: #2e4457 !important;
  color: white !important;

}
.p-select-list-container{
  border-radius: 0.375rem !important;
  margin: 0 !important;
}
</style>
